import React, { useState, useEffect } from "react";
import SparkApi from "../api/SparkApi";
import { Button, Col, Container, Form, Modal, Row , Accordion, Table } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { DatatableWrapper, TableBody, TableHeader } from "react-bs-datatable";

const UserView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(location.state ? location.state : {});
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [permissionData, setPermissionData] = useState();
  const [upsertRolePermissions, setUpsertRolePermissions] = useState([]);
  const [readAllModuleCheck, setReadAllModuleCheck] = useState([]);
  const [tabCheckBox, setTabCheckBox] = useState({
    read_all: null,
    create_all: null,
    edit_all: null,
    delete_all: null,
    select_all_box: null,
  });
  const [isResponse , setIsReponse] = useState(false)
  
  const fetchPermission = async () => {
    try {
      const permissionData = await SparkApi.fetchRolePermissions(user.id);
      let sortedModules = [...permissionData.result].sort(
        (a, b) => a.order_no - b.order_no
      );

      if (user.userrole === "USER") {
        sortedModules = sortedModules.filter(
          (module) => module.url !== "/users"
        );
      }
      
      if (sortedModules) {
        setPermissionData(sortedModules);
      } else {
        setPermissionData({});
      }
    } catch (error) {
      console.error("Error fetching rack:", error);
    }
  };

  useEffect(() => {
    fetchUserById();
    fetchPermission();
  }, []);

  const handlePasswordOnchange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const fetchUserById = () => {
    if (
      location.hasOwnProperty("pathname") &&
      location.pathname.split("/").length >= 3
    ) {
      user.id = location.pathname.split("/")[2];
    }

    async function inituser() {
      let result = await SparkApi.fetchUserById(user.id);
      setUser(result);
    }
    inituser();
  };

  const editUser = (row) => {
    navigate(`/users/${user.id}/e`, { state: user });
  };

  const handleChangeSubmit = async (e) => {
    e.preventDefault();

    if (!user.password || !user.confirmpassword) {
      return toast.error("Missing required feild");
    } if (user.password.length < 6 || user.confirmpassword.length < 6) {
      return toast.error("Password and ConfirmPassword should be atleast 6 charcters");
    }

    if (user.password === user.confirmpassword && user.password !== "") {
      let newUser = { id: user.id, password: user.password };
      const result = await SparkApi.saveUser(newUser);
      setShowPasswordModal(false);
      toast.success("Password updated successfully");
    } else {
      toast.error("Either password do not match or not entered");
    }
  };

  const handleClose = () => setShowPasswordModal(false);

  const handleCheckBox = (columnName, row) => (e) => {
    const checked = e.target.checked;
    console.log('checked-->',checked);
    console.log('columnName-->',columnName);
   
    if (columnName === "select_all_box") {
      setTabCheckBox({
        read_all: checked,
        create_all: checked,
        edit_all: checked,
        delete_all: checked,
        select_all_box: checked,
      });

      setPermissionData((oldRolePermissions) => {
        const updatedRolePermissions = oldRolePermissions.map((record) => ({
            ...record,
            can_read: checked,
            can_create: checked,
            can_edit: checked,
            can_delete: checked,
        }));
        console.log("updatedRolePermissions == ", updatedRolePermissions);
        return updatedRolePermissions;
      });

      if (e.target.id === "Module") {
        setReadAllModuleCheck(checked);
      }
    } 
    else if (columnName === "read_all" || columnName === "create_all" || columnName === "edit_all" || columnName === "delete_all") {
      if (columnName === "read_all")
        setTabCheckBox((prev) => ({ ...prev, read_all: checked }));
      else if (columnName === "create_all")
        setTabCheckBox((prev) => ({ ...prev, create_all: checked }));
      else if (columnName === "edit_all")
        setTabCheckBox((prev) => ({ ...prev, edit_all: checked }));
      else setTabCheckBox((prev) => ({ ...prev, delete_all: checked }));

      setPermissionData((oldRolePermissions) => {
        const updatedRolePermissions = [...oldRolePermissions];
        
        updatedRolePermissions.forEach((item) => {
          if (columnName === "read_all") item.can_read = e.target.checked;
          else if (columnName === "create_all"){
            item.can_read = true;
            item.can_create = e.target.checked;
          }
          else if (columnName === "edit_all"){
            item.can_read = true;
            item.can_edit = e.target.checked;
          }
          else if (columnName === "delete_all"){
            item.can_read = true;
            item.can_delete = e.target.checked;
          }
        });

        setUpsertRolePermissions(updatedRolePermissions);
        return updatedRolePermissions;
      });
    }
     else {
      setPermissionData((oldRolePermissions) => {
        const updatedRolePermissions = [...oldRolePermissions];

        const rolePermission = updatedRolePermissions?.find((perm) => perm.module_id === row.module_id);
        if (!rolePermission) return updatedRolePermissions;

        if (["can_read", "can_create", "can_edit", "can_delete"].includes(columnName)) {
          rolePermission[columnName] = checked;

          if (["can_create", "can_edit", "can_delete"].includes(columnName) && checked) {
            rolePermission.can_read = true;
            if (updatedRolePermissions?.every((perm) => perm.can_read === true)) {
              setTabCheckBox((prev) => ({ ...prev, read_all: true }));
            }
          }
        }

        // Handle select_all logic
        if (columnName === "select_all") {
          rolePermission.can_edit = checked;
          rolePermission.can_create = checked;
          rolePermission.can_read = checked;
          rolePermission.can_delete = checked;

          const isAllPemissions = updatedRolePermissions?.every((permission) =>
              permission.can_read === true &&
              permission.can_create === true &&
              permission.can_edit === true &&
              permission.can_delete === true
          );

          if (isAllPemissions) {
            setTabCheckBox({
              read_all: true,
              create_all: true,
              edit_all: true,
              delete_all: true,
              select_all_box: true,
            });
          } else {
            setTabCheckBox({
              read_all: updatedRolePermissions.every((perm) => perm.can_read === true),
              create_all: updatedRolePermissions.every((perm) => perm.can_create === true),
              edit_all: updatedRolePermissions.every((perm) => perm.can_edit === true),
              delete_all: updatedRolePermissions.every((perm) => perm.can_delete === true),
            });
          }
        }

        // Update select_all based on individual permissions
        rolePermission.select_all = ["can_edit", "can_create", "can_read", "can_delete"].every((perm) => rolePermission[perm]);

        updatedRolePermissions?.every((perm) => perm.can_read === true) ? setTabCheckBox((prev) => ({ ...prev, read_all: true })) : setTabCheckBox((prev) => ({ ...prev, read_all: false }));
        updatedRolePermissions?.every((perm) => perm.can_create === true) ? setTabCheckBox((prev) => ({ ...prev, create_all: true })) : setTabCheckBox((prev) => ({ ...prev, create_all: false }));
        updatedRolePermissions?.every((perm) => perm.can_edit === true) ? setTabCheckBox((prev) => ({ ...prev, edit_all: true })) : setTabCheckBox((prev) => ({ ...prev, edit_all: false }));
        updatedRolePermissions?.every((perm) => perm.can_delete === true) ? setTabCheckBox((prev) => ({ ...prev, delete_all: true })) : setTabCheckBox((prev) => ({ ...prev, delete_all: false }));

        const checkReadAll = updatedRolePermissions?.every((perm) => perm.can_read === true) ? true : false;
        console.log("checkReadAll == ", checkReadAll);
        if (checkReadAll) {
          if (e.target.id === "Module") {
            setReadAllModuleCheck(checkReadAll);
          }
        } else {
          console.log("else me aya");
          if (e.target.id === "Module") {
            setReadAllModuleCheck(checkReadAll);
          }
        }

        const upsertIndex = upsertRolePermissions.findIndex((record) => record.user_id === row.user_id && record.module_id === row.module_id);
        const newUpsertPermissions = upsertRolePermissions.slice();
        if (upsertIndex > -1) {
          newUpsertPermissions[upsertIndex] = rolePermission; 
        } else {
          newUpsertPermissions.push(rolePermission); 
        }

        setUpsertRolePermissions(newUpsertPermissions);
        return updatedRolePermissions;
      });
    }
  };

  console.log('permissionData-->',permissionData);

  const handleSaveChanges = async (e) => {
    try {
      setIsReponse(true);
      const result = await SparkApi.upsertRolePermissions(permissionData);
      if (result.success) {
        setTimeout(() => {
          setIsReponse(false);
        }, 2000);
        toast.success("Record updated successfully");
      } else {
        toast.error("Record not updated..!!", {
          className: "toast-error",
        });
      }
    } catch (error) {
      console.log("SERVER_ERROR-->>", error);
      toast.error(error.response.data.message, {
        className: "toast-error",
      });
    }
  };

  const Header = [
    { title: "Modules", prop: "name", isFilterable: true },
    {
      title: (
        <span>
          Read
          <Form.Check
            disabled={user?.userrole === "ADMIN"}
            type="checkbox"
            onChange={handleCheckBox("read_all", {
              // roleid: role,
              module_name: "Module",
            })}
            checked={permissionData?.every((permission) => permission?.can_read === true)}
          />
        </span>
      ),
      prop: "can_read",
      isFilterable: true,
      cell: (row) =>
        row.can_read &&
        (row?.can_create || row?.can_edit || row?.can_delete) ? (
          <Form.Check
            disabled={user?.userrole === "ADMIN"}
            id="Module"
            type="checkbox"
            onChange={handleCheckBox("can_read", row)}
            checked={
              row.can_read ||
              row?.can_create ||
              row?.can_edit ||
              row?.can_delete
            }
          />
        ) : (
          <Form.Check
            disabled={user?.userrole === "ADMIN"}
            id="Module"
            type="checkbox"
            onChange={handleCheckBox("can_read", row)}
            checked={row.can_read}
          />
        ),
    },
    {
      title: (
        <span>
          Create
          <Form.Check
            disabled={user?.userrole === "ADMIN"}
            type="checkbox"
            onChange={handleCheckBox("create_all")}
            checked={permissionData?.every((permission) => permission?.can_create === true)}
          />
        </span>
      ),
      prop: "can_create",
      isFilterable: true,
      cell: (row) => (
        <Form.Check
          disabled={user?.userrole === "ADMIN"}
          type="checkbox"
          onChange={handleCheckBox("can_create", row)}
          checked={row.can_create}
        />
      ),
    },
    {
      title: (
        <span>
          Edit
          <Form.Check
            disabled={user?.userrole === "ADMIN"}
            type="checkbox"
            onChange={handleCheckBox("edit_all")}
            checked={permissionData?.every((permission) => permission?.can_edit === true)}
          />
        </span>
      ),
      prop: "can_edit",
      isFilterable: true,
      cell: (row) => (
        <Form.Check
          disabled={user?.userrole === "ADMIN"}
          type="checkbox"
          onChange={handleCheckBox("can_edit", row)}
          checked={row.can_edit}
        />
      ),
    },
    {
      title: (
        <>
          Delete
          <Form.Check
            disabled={user?.userrole === "ADMIN"}
            type="checkbox"
            onChange={handleCheckBox("delete_all")}
            checked={permissionData?.every((permission) => permission?.can_delete === true)}
          />
        </>
      ),
      prop: "can_delete",
      isFilterable: true,
      cell: (row) => (
        <Form.Check
          disabled={user?.userrole === "ADMIN"}
          type="checkbox"
          onChange={handleCheckBox("can_delete", row)}
          checked={row.can_delete}
        />
      ),
    },
    {
      title: (
        <div className="d-flex">
          <div>
            Select All
            <Form.Check
              disabled={user?.userrole === "ADMIN"}
              id="Module"
              type="checkbox"
              onChange={handleCheckBox("select_all_box")}
              checked={
                (tabCheckBox.create_all &&
                tabCheckBox.read_all &&
                tabCheckBox.edit_all &&
                tabCheckBox.delete_all) ||
                permissionData?.every((permission) =>
                  (permission?.can_read === true || readAllModuleCheck) &&
                  permission?.can_create === true &&
                  permission?.can_edit === true &&
                  permission?.can_delete === true
                )
              }
            />
          </div>
          <div className="ms-auto">
            <Button
              disabled={user?.userrole === "ADMIN"}
              className="btn-sm my-1 mx-3"
              variant="primary"
              onClick={handleSaveChanges}
              // disabled={isResponse}
            >
                Save
            </Button>
          </div>
        </div>
      ),
      prop: "select_all",
      isFilterable: true,
      cell: (row) => (
        <Form.Check
          disabled={user?.userrole === "ADMIN"}
          id="Module"
          type="checkbox"
          onChange={handleCheckBox("select_all", row)}
          checked={row.can_create && row?.can_read && row?.can_edit && row?.can_delete}
        />
      ),
    },
  ];

  return (
    <div>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        theme="light"
        pauseOnHover
      />
      
      <Container>
        <Modal
          show={showPasswordModal}
          onHide={handleClose}
          className="modal-md"
        >
          <Modal.Header closeButton className="view-form-header">
            <Modal.Title>Change Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col></Col>
              <Col lg={12}>
                <Form className="mt-3">
                  <Row>
                    <Col>
                      <Form.Group className="mx-3">
                        <Form.Label className="form-view-label">New Password</Form.Label>
                        <Form.Control
                          type="password"
                          name="password"
                          placeholder="Enter Your password"
                          onChange={handlePasswordOnchange}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group className="mx-3">
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicPhone"
                        >
                          Confirm Password
                        </Form.Label>
                        <Form.Control
                          type="password"
                          name="confirmpassword"
                          placeholder="Enter confirm password"
                          onChange={handlePasswordOnchange}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </Col>
              <Col></Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary btn-sm" onClick={handleChangeSubmit}>
              Save
            </Button>
            <Button variant="danger btn-sm" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Row className="view-form">
          <Col lg={11} className="pb-3 pt-2">
            <Link className="nav-link" to="/users">
              Home <i className="fa-solid fa-chevron-right"></i>{" "}
              <div style={{ color: "#23468c", display: "inline" }}>Users</div>
            </Link>
          </Col>
          <Col></Col>
        </Row>
        <Row className="view-form">
          <Col></Col>
          <Col lg={8}>
            <Row className="view-form-header align-items-center">
              <Col lg={3}>User</Col>
              <Col lg={9} className="d-flex justify-content-end">
                <Button className="btn-sm mx-2 btn-sm" onClick={() => editUser(true)}>
                  <i class="fa-regular fa-pen-to-square"></i>
                </Button>
              </Col>
            </Row>
            <Row className="ibs-edit-form py-3">
              <Col lg={6}>
                <label>First Name</label>
                <span>{user.firstname}</span>
              </Col>
              <Col lg={6}>
                <label>Last Name</label>
                <span>{user.lastname}</span>
              </Col>
              <Col lg={6}>
                <label>Email</label>
                <span>{user.email}</span>
              </Col>
              <Col lg={6}>
                <label>Phone</label>
                <span>{user.phone}</span>
              </Col>
              <Col lg={6}>
                <label>User Role</label>
                <span>{user.userrole}</span>
              </Col>
              <Col lg={6}>
                <label>Active</label>
                <span>
                  {user.isactive === true && (
                    <i
                      class="fa-regular fa-square-check"
                      style={{ fontSize: "1.3rem" }}
                    ></i>
                  )}{" "}
                  {user.isactive === false && (
                    <i
                      class="fa-regular fa-square"
                      style={{ fontSize: "1.3rem" }}
                    ></i>
                  )}{" "}
                </span>
              </Col>
            </Row>
          </Col>
          <Col></Col>
        </Row>

        <Row className="py-2 px-2 mx-lg-3 text-white fw-bold" style={{ background: "#1d777f" }}>
          <Col lg={12}>
            <h6 className="mb-0">User Permissions</h6>
          </Col>
        </Row>

        <Row className="my-3 mx-lg-2">
          <Col lg={12}> 
            <DatatableWrapper
                headers={Header}
                body={permissionData || []}
              >
                <Table className="data-table permission-table" responsive>
                  <TableHeader />
                  <TableBody />
                </Table>
              </DatatableWrapper>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default UserView;
